import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import { modifyGroupedIdsSort, sortArrayBy } from '@domain-group/javascript-utils'

import type { CampaignQuoteSectionModel } from '@models/campaignQuoteSection'

type DefaultState = {
  sortedIds: (number | undefined)[],
}

type SetState = (state: Partial<DefaultState>) => void

type ModifyCampaignQuoteSectionSortParams = {
  fromIndex: number,
  payload: { [key: string]: any },
  setState: SetState,
  sortedIds: (number | undefined)[],
  toIndex: number,
}

const modifyCampaignQuoteSectionSort = (params: ModifyCampaignQuoteSectionSortParams) => {
  const {
    fromIndex, payload, setState, sortedIds, toIndex,
  } = params

  // @ts-expect-error TS2322
  const groupedIds = modifyGroupedIdsSort(fromIndex, toIndex, payload, { sortedIds })
  // @ts-expect-error TS2345
  setState({ sortedIds: groupedIds.sortedIds })
}

type UseEditCampaignQuoteSectionSortOptions = {
    filteredCampaignQuoteSections: CampaignQuoteSectionModel[],
}

const defaultState: DefaultState = {
  sortedIds: [],
}

function useEditCampaignQuoteSectionSort(options: UseEditCampaignQuoteSectionSortOptions) {
  const { filteredCampaignQuoteSections = [] } = options || {}

  const [state, setState] = useSetState(defaultState)
  const { sortedIds } = state

  const sortedSections = sortArrayBy(filteredCampaignQuoteSections, 'asc', 'sort')

  // Set current sort into state
  useEffect(() => {
    const sortedSectionIds = sortedSections.map(item => item?.id)
    setState({ sortedIds: sortedSectionIds })
  }, [filteredCampaignQuoteSections.length])

  return {
    callbacks: {
      modifyCampaignQuoteSectionSort: (
        fromIndex: number,
        toIndex: number,
        payload: { [key: string]: any },
      ) => modifyCampaignQuoteSectionSort({
        fromIndex,
        payload,
        setState,
        sortedIds,
        toIndex,
      }),
    },
    sortedIds,
  }
}

export default useEditCampaignQuoteSectionSort
